export default __webpack_public_path__ + "static/media/attach_money-blue.ca8252d3.svg";